import React, { createContext, useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleTheme } from '../redux/slices/themeSlice';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.theme.mode);
  const [isDark, setIsDark] = useState(theme === 'dark');

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    const isDarkMode = savedTheme === 'dark';
    setIsDark(isDarkMode);
    document.documentElement.className = isDarkMode ? 'dark-theme' : 'light-theme';
    document.body.className = isDarkMode ? 'dark-theme' : 'light-theme';
    dispatch(toggleTheme(isDarkMode ? 'dark' : 'light'));
  }, [dispatch]);

  const toggleThemeMode = () => {
    const newTheme = !isDark;
    setIsDark(newTheme);
    const themeMode = newTheme ? 'dark' : 'light';
    document.documentElement.className = themeMode + '-theme';
    document.body.className = themeMode + '-theme';
    localStorage.setItem('theme', themeMode);
    dispatch(toggleTheme(themeMode));
  };

  return (
    <ThemeContext.Provider value={{ isDark, toggleThemeMode }}>
      {children}
    </ThemeContext.Provider>
  );
};